<template>
	<div>
		<el-dialog title="群公告" :visible.sync="visiable" width="360px" >
			<div class="select-content" v-if="Object.keys(data).length > 0">
				<el-input type="textarea" rows="6" placeholder="请输入群公告" v-model="data.group.notice"></el-input>
			</div>	
			<span slot="footer" class="dialog-footer">
				<el-button
				  type="primary"
				  @click="setGroupData"
				>保存</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	import  Vue  from 'vue'
	import { mapState, mapActions} from 'vuex'
	import { getChatDetails, setGroupData} from '@/api'
	import { Message } from 'element-ui';
	export default {
	
		data() {
			return {
				data:{},
				visiable: false,
			}
		},
		computed: {
		  ...mapState([
		    'selectId',
		  	'groupDetail'
		  ]),
		},
		created() {
			
		},
		methods: {
			...mapActions(['setGroupDetail']),
			handleGroupManager() {
				this.$refs.groupManager.open()
			},
			setGroupData () {
			  setGroupData({
			    list_id: this.selectId,
				type:'notice',
				content:this.data.group.notice
			  }).then(res => {
					Message({
					   showClose: true,
					   message: "修改成功",
					   type: 'success',
					   duration: 1000
					})
					this.visiable = false
					this.groupDetail.group.notice = this.data.group.notice;
					this.setGroupDetail(this.groupDetail);
			  })
			},
			
			open() {
				this.visiable = true;
				this.data = this.groupDetail;
	
			}
		}
	}
</script>

<style lang="less" scoped>

</style>
